<template>
	<v-row class="mx-0">
		<v-col
			:cols="12"
		>
			<h1>
				<router-link
					:to="`/machines/vendors/${machine.vendor.id}`"
					class="text-decoration-none"
				>
					{{ machine.vendor.name }}
				</router-link>
				{{ machine.model_name }}
			</h1>
		</v-col>

		<v-col cols="6">
			<v-card outlined>
				<v-card-text>
					<h3>Товары</h3>
					<v-divider class="my-2"/>

					<v-list>
						<v-list-item
							v-for="productPivot in machine.products"
							:key="productPivot.product.id"
							class="justify-space-between px-0"
							style="min-height: 0 !important;"
						>
							<router-link
								:to="`/products/${productPivot.product.id}`"
								class="text-decoration-none"
							>
								{{ productPivot.product.name }}
							</router-link>

							<v-spacer/>

							<code>{{ productPivot.vendor_code }}</code>
						</v-list-item>
					</v-list>
				</v-card-text>
			</v-card>
		</v-col>
	</v-row>
</template>

<script>
import Vue from 'vue';

const EMPTY_MACHINE = () => ({
	vendor: {},
});

export default {
	name: 'Show',
	data: () => ({
		machine: EMPTY_MACHINE(),
	}),
	async beforeRouteEnter(to, from, next) {
		try {
			const response = await Vue.prototype.$http.get(`/api/v2/schemes/machines/${to.params.id}`);
			next(vm => {
				vm.machine = response.data.data
			});
		} catch (e) {
			next(false);
		}
	},
	mounted() {
	},
	methods: {},
}
</script>

<style scoped>

</style>
